export default function (message, fields) {
  return {
    message,
    fields,
  }
}
